export default (result) =>
  result.map((city) => ({
    ...city,
    type: 'city',
    text: `${city.name}, Россия`,
  }));
